import api from './axios';

export const getAdminInitialData = (userId) => api.get(`/diet-plans/admin/${userId}/initial-data`);
export const saveAdminInitialData = (userId, data) => api.put(`/diet-plans/admin/${userId}/initial-data`, data);
